import type { App } from 'vue';
import {
  AdminModule,
  FavoritesModule,
  FeedbackModule,
  NotificationsModule,
  KnowledgeModule,
  SearchModule,
  ToastsModule,
  AskModule,
  CopilotModule,
} from '@getmayday/vue-modules';
import { AgentModule } from '@getmayday/vue-modules/agent';
import type { AxiosInstance } from 'axios';
import type { Pinia } from 'pinia';
import type { I18n } from 'vue-i18n';

type Clients = {
  adminClient: AxiosInstance;
  authClient: AxiosInstance;
  knowledgeClient: AxiosInstance;
  notificationClient: AxiosInstance;
  brainClient: AxiosInstance;
  academyClient: AxiosInstance;
  logClient: any;
  fetchClient: any;
};

export const useModules = (
  app: App,
  pinia: Pinia,
  i18n: I18n,
  clients: Clients,
  appFunctions: AppFunctions,
  source: string,
) => {
  const {
    adminClient,
    knowledgeClient,
    notificationClient,
    authClient,
    brainClient,
    fetchClient,
    academyClient,
  } = clients;

  app.use(AdminModule.plugin, {
    pinia,
    authClient,
    adminClient,
    brainClient,
    i18n,
    frontUrl: import.meta.env.VITE_APP_FRONT_URL,
    ssoUrl: import.meta.env.VITE_APP_SSO_URL,
    source,
    appFunctions,
  });
  app.use(KnowledgeModule.plugin, {
    pinia,
    knowledgeClient,
    adminClient,
    i18n,
    appFunctions,
    brainClient,
  });
  app.use(FavoritesModule.plugin, {
    pinia,
    knowledgeClient,
    i18n,
    appFunctions,
  });
  app.use(NotificationsModule.plugin, {
    pinia,
    notificationClient,
    adminClient,
    knowledgeClient,
    i18n,
    appFunctions,
    academyClient,
    brainClient,
  });
  app.use(SearchModule.plugin, {
    pinia,
    knowledgeClient,
    brainClient,
    i18n,
    appFunctions,
  });
  app.use(FeedbackModule.plugin, {
    pinia,
    adminClient,
    knowledgeClient,
    i18n,
    appFunctions,
  });
  app.use(AskModule.plugin, {
    pinia,
    i18n,
    appFunctions,
    brainClient,
    fetchClient,
    knowledgeClient,
  });
  app.use(ToastsModule.plugin, { pinia, i18n, appFunctions });
  app.use(CopilotModule.plugin, {
    pinia,
    i18n,
    appFunctions,
    adminClient,
    brainClient,
    knowledgeClient,
  });
  app.use(AgentModule.plugin, {
    pinia,
    i18n,
    appFunctions,
    adminClient,
    brainClient,
    knowledgeClient,
    academyClient,
  });

  app.provide('hostApp', source);
};
